import { ServiceData } from '../../service';
import db from '../../index';
import { entityServiceFactory } from '../../entityServiceFactory';

export interface RequirementsServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<RequirementsServiceData>(db, 'requirementsService');

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
